import React, { useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import img from "../../assets/sign-in-back.svg";
import { handleError, handleSuccess } from "../../Utils";
import {
  createReferrals,
  sendEmailOtp,
  sendNumberOtp,
  userSignup,
  verifyEmailOtp,
  verifyNumberOtp,
} from "../../ApiServices/ApiServices";
import { useSearchParams } from 'react-router-dom';

const Signup = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [mailOtp, setMailOtp] = useState("");
  const [numOtp, setNumOtp] = useState("");
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("");
  const [isEditableNum, setIsEditableNum] = useState(true);
  const [isEditableEmail, setIsEditableEmail] = useState(true);
  const [isNumOtpInputVisible, setIsNumOtpInputVisible] = useState(false);
  const [isEmailOtpInputVisible, setIsEmailOtpInputVisible] = useState(false);
  const [isFullDetails, setIsFullDetails] = useState(false);
  const [isBackBtnVisible, setIsBackBtnVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/dashboard";
  const [loading, setLoading] = useState(false);
  const [hasVerifiedMailOtp, setHasVerifiedMailOtp] = useState(false);
  const [hasVerifiedNumOtp, setHasVerifiedNumOtp] = useState(false);
  const [timerEmailOtp, setTimerEmailOtp] = useState(0);
  const [timerNumOtp, setTimerNumOtp] = useState(0);

  const [searchParams] = useSearchParams();
  const referralCode = searchParams.get('ref');

  useEffect(() => {
    document.title = "Codequeue - Signup";
  }, []);

  useEffect(() => {
    let interval = null;
    if (timerEmailOtp > 0) {
      interval = setInterval(() => {
        setTimerEmailOtp((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timerEmailOtp]);

  useEffect(() => {
    let interval = null;
    if (timerNumOtp > 0) {
      interval = setInterval(() => {
        setTimerNumOtp((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timerNumOtp]);

  // send otp on email
  const emailOtpSend = async () => {
    if (timerEmailOtp > 0) return; // Prevent sending again while timer is running
    try {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(email)) {
        return handleError("Please Enter Valid Email.");
      }
      const response = await sendEmailOtp(email);
      setIsEmailOtpInputVisible(true);
      setTimerEmailOtp(30);
      return handleSuccess(response.message);
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }
  };
  // verify email otp
  const emailOtpVerify = async () => {
    try {
      const response = await verifyEmailOtp(email, mailOtp);
      setHasVerifiedMailOtp(response?.success);
      setMailOtp("");
      setIsEmailOtpInputVisible(false);
      setIsEditableEmail(false);
      return handleSuccess(response.message);
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }
  };
  // send otp on number
  const numOtpSend = async () => {
    if (timerNumOtp > 0) return; // Prevent sending again while timer is running
    try {
      const phoneRegex = /^\d{10}$/; // Ensures exactly 10 digits
      if (!phoneRegex.test(phone)) {
        return handleError("Phone number must be exactly 10 digits.");
      }
      const response = await sendNumberOtp(phone);
      setIsNumOtpInputVisible(true);
      setTimerNumOtp(30);
      return handleSuccess(response.message);
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }
  };
  // verify num otp
  const numOtpVerify = async () => {
    try {
      const otp = numOtp;
      const response = await verifyNumberOtp(phone, otp);
      setHasVerifiedNumOtp(response?.success);
      setNumOtp("");
      setIsNumOtpInputVisible(false);
      setIsEditableNum(false);
      return handleSuccess(response.message);
    } catch (error) {
      return handleError(error.response.data.message);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isFullDetails) {
      if (!hasVerifiedMailOtp) return handleError("Please verify your email!");
      if (!hasVerifiedNumOtp)
        return handleError("Please verify your phone number!");
      setIsFullDetails(true);
      setIsBackBtnVisible(true);
    } else {
      if (!name || !email || !phone || !password) {
        return handleError("All fields are required");
      }

      if (name.length < 3) {
        return handleError("Name must be at least 3 characters long.");
      }

      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(email)) {
        return handleError("Please Enter Valid Email.");
      }

      const phoneRegex = /^\d{10}$/; // Ensures exactly 10 digits
      if (!phoneRegex.test(phone)) {
        return handleError("Phone number must be exactly 10 digits.");
      }

      if (password.length < 6 || password.length > 12) {
        return handleError("Password must be between 6 and 12 characters.");
      }

      try {
        setLoading(true);
        // creating new user profile
        const response = await userSignup(name, email, phone, password, dob, gender);
        setName("");
        setEmail("");
        setPhone("");
        setPassword("");

        //referral process if referral code is present
        if (referralCode) {
          const referralsData = {};
          referralsData.referralCode = referralCode;
          referralsData.email = email;
          referralsData.role = "user";
          referralsData.name = name;
          await createReferrals(referralsData);
        }
        handleSuccess(response.message);
        setTimeout(() => {
          navigate(from);
        }, 2000);
      } catch (error) {
        return handleError(error?.response?.data?.message);
      } finally {
        setLoading(false);
      }
    }
  };

  const getback = (e) => {
    e.preventDefault();
    setIsFullDetails(false);
    setIsBackBtnVisible(false);
  };

  return (
    <div className="flex justify-center flex-wrap py-8 pt-24">
      {/* pt-24 adds space for navbar */}
      <div className=" flex-col gap-5 w-full  max-w-sm px-1">
        <div className="  gap-5">
          <div>
            <h1 className="font-bold text-4xl">Create your profile</h1>
            <p>Surround Yourself with Brilliance—Start with CodeQueue.</p>
          </div>
        </div>

        <div>
          <form
            onSubmit={handleSubmit}
            className="login-form signup-form flex flex-col"
          >
            <div className=" ">
              <div
                className={`form-group ${isFullDetails ? "hidden" : ""} mb-6`}
              >
                <label htmlFor="email" className="font-bold text-[16px]">
                  Email :{" "}
                </label>
                <div className="otp flex">
                  <input
                    type="email"
                    id="email"
                    readOnly={!isEditableEmail}
                    value={email}
                    placeholder="Email"
                    onChange={(e) =>
                      setEmail(e.target.value.trim().toLowerCase())
                    }
                    className="h-12 w-[300px] px-4 border border-gray-300 rounded-md"
                  />
                  <span
                    onClick={() => {
                      if (hasVerifiedMailOtp || timerEmailOtp > 0) return null;
                      emailOtpSend();
                    }}
                    className={`flex h-12 w-20 justify-center items-center rounded-tr-md rounded-br-md font-bold ${
                      hasVerifiedMailOtp
                        ? "bg-green-600 text-white cursor-not-allowed"
                        : "hover:bg-gray-500 active:bg-gray-600 bg-gray-400 text-gray-900 cursor-pointer"
                    }`}
                  >
                    {hasVerifiedMailOtp ? "Verified" : "Verify"}
                  </span>
                </div>
                {timerEmailOtp > 0 && !hasVerifiedMailOtp && (
                  <p className="text-[12px] text-yellow-600">
                    OTP resend in {timerEmailOtp}s
                  </p>
                )}
                {isEmailOtpInputVisible && (
                  <div className="otp-verify flex items-center gap-2 mt-2">
                    <input
                      type="text"
                      placeholder="Enter OTP"
                      value={mailOtp}
                      onChange={(e) => setMailOtp(e.target.value)}
                      className="h-12 w-[300px] px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-200"
                    />
                    <button
                      type="button"
                      onClick={emailOtpVerify}
                      className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700"
                    >
                      Verify
                    </button>
                  </div>
                )}
              </div>

              <div
                className={`form-group ${isFullDetails ? "hidden" : ""} mb-6`}
              >
                <label htmlFor="phone" className="font-bold text-[16px]">
                  Phone :{" "}
                </label>
                <div className="otp flex">
                  <input
                    type="text"
                    id="phone"
                    value={phone}
                    placeholder="Phone number"
                    readOnly={!isEditableNum}
                    onChange={(e) => setPhone(e.target.value)}
                    className="h-12 px-4 border border-gray-300 w-[300px] rounded-md"
                  />
                  <span
                    onClick={() => {
                      if (hasVerifiedNumOtp || timerNumOtp > 0) return null;
                      numOtpSend();
                    }}
                    className={`flex h-12 w-20 justify-center items-center rounded-tr-md rounded-br-md font-bold ${
                      hasVerifiedNumOtp
                        ? "bg-green-600 text-white cursor-not-allowed"
                        : "hover:bg-gray-500 active:bg-gray-600 bg-gray-400 text-gray-900 cursor-pointer"
                    }`}
                  >
                    {hasVerifiedNumOtp ? "Verified" : "Verify"}
                  </span>
                </div>
                {timerNumOtp > 0 && !hasVerifiedNumOtp && (
                  <p className="text-[12px] text-yellow-600">
                    OTP resend in {timerNumOtp}s
                  </p>
                )}
                {isNumOtpInputVisible && (
                  <div className="otp-verify flex items-center gap-2 mt-2">
                    <input
                      type="text"
                      placeholder="Enter OTP"
                      value={numOtp}
                      onChange={(e) => setNumOtp(e.target.value)}
                      className="h-12 w-[300px] px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-200"
                    />
                    <button
                      type="button"
                      onClick={numOtpVerify}
                      className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700"
                    >
                      Verify
                    </button>
                  </div>
                )}
              </div>

              {/* Name and Password fields will appear after clicking Next */}
              <div
                className={`form-group ${isFullDetails ? "" : "hidden"} mb-6`}
              >
                <label htmlFor="name" className="font-bold text-[16px]">
                  Name:
                </label>
                <input
                  type="text"
                  id="name"
                  value={name}
                  placeholder="Your name"
                  onChange={(e) => setName(e.target.value)}
                  className="h-12 px-4 w-full sm:w-[380px] border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div className={`form-group ${isFullDetails ? "" : "hidden"} mb-6`}>
                <label htmlFor="dob" className="font-bold text-[16px]">
                  Date of Birth:
                </label>
                <input
                  type="date"
                  id="dob"
                  value={dob}
                  onChange={(e) => setDob(e.target.value)}
                  className="h-12 px-4 w-full sm:w-[380px] border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div className={`form-group ${isFullDetails ? "" : "hidden"} mb-6`}>
                <label htmlFor="gender" className="font-bold text-[16px]">
                  Gender:
                </label>
                <select
                  id="gender"
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}
                  className="h-12 px-4 w-full sm:w-[380px] border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Select Gender</option>
                  <option value="female">Female</option>
                  <option value="male">Male</option>
                  <option value="other">Other</option>
                  <option value="prefer_not_to_say">Prefer not to say</option>
                </select>
              </div>

              <div
                className={`form-group ${isFullDetails ? "" : "hidden"} mb-6`}
              >
                <label htmlFor="password" className="font-bold text-[16px]">
                  Password:
                </label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  placeholder="Password"
                  onChange={(e) => setPassword(e.target.value)}
                  className="h-12 px-4 w-full sm:w-[380px] border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div className="flex justify-between items-center w-full ">
                <button
                  onClick={getback}
                  className={`${isFullDetails ? "" : "hidden"} secondary-btn ${
                    isBackBtnVisible ? "visible" : "invisible"
                  }`}
                >
                  Back
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="primary-btn"
                >
                  {isFullDetails ? (
                    loading ? (
                      <div className="spinner" />
                    ) : (
                      "Submit"
                    )
                  ) : (
                    "Next"
                  )}
                </button>
              </div>
            </div>
            <div className="forgot-password text-center mt-4">
              Join as a Mentor{" "}
              <NavLink to={"/onboarding"} state={{ referralCode }} className="underline text-blue-700">
                Click here
              </NavLink>
            </div>
            <div className="divider my-4">
              <hr className="divider-line bg-gray-300 h-px" />
            </div>

            <NavLink
              to={"/login"}
              className="forgot-password as-mentor hover text-center text-blue-500"
            >
              Already have an account?
            </NavLink>
          </form>
        </div>
      </div>
      <div className="right w-full max-w-lg pt-10  bg-cover bg-center overflow-hidden flex justify-center">
        <img src={img} alt="Img" className="w-full  max-w-full" />
      </div>
    </div>
  );
};

export default Signup;
